import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { format } from "date-fns";

import { API, graphqlOperation } from "aws-amplify";
import { getInventorieTimeline } from "../../../../graphql/inventory/custom-queries";
import { getOutboundShipmentTimeline } from "../../../../graphql/outbound/custom-queries";

import { useNotify } from "react-admin";

import {
  Button,
  CardActions,
  Divider,
  IconButton,
  CircularProgress,
  Box,
  Paper,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  useMediaQuery,
  List,
  ListItem,
  ListItemText,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Backdrop,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  CardContent,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import NoteOutlinedIcon from "@material-ui/icons/NoteOutlined";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import HistoryIcon from "@material-ui/icons/History";
import CheckBoxOutlineBlankOutlinedIcon from "@material-ui/icons/CheckBoxOutlineBlankOutlined";

import {
  ExceptionIcon,
  InboundIcon,
  OutboundIcon,
} from "../../../../components/common/iconography";
import CrewCard from "../../../../components/common/CrewCard";
import { CustomFieldsMobile } from "../../../../components/common/CustomFields";
import PhotoManager from "../../../../components/common/PhotoManager";

import { logError } from "../../../../utils/appUtils";
import { UserType } from "../../../../utils/constants";
import { getUnitName } from "../../../../utils/loadTypeUtils";
import { calcTotalQuantity } from "../../../../managerApp/resources/outboundShipments/OutboundUtils";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 90001,
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  timeLineItem: {
    maxWidth: theme.spacing(16),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  timeLineItemMobile: {
    maxWidth: theme.spacing(10),
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0.5),
  },
  historyButton: {
    maxWidth: theme.spacing(16),
    marginLeft: theme.spacing(-1),
    marginRight: theme.spacing(2),
  },
  link: {
    color: "inherit",
    textDecoration: "inherit",
  },
}));

export const InventoryTimeline = ({ history, match }) => {
  const [headerData, setHeaderData] = useState();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));

  const handleCancel = () => {
    history.goBack();
  };

  return (
    <CrewCard
      title={headerData?.productName}
      icon={
        isSmall ? null : <CheckBoxOutlineBlankOutlinedIcon fontSize="large" />
      }
      subheader={headerData?.accountName}
      action={
        <IconButton edge="start" onClick={handleCancel}>
          <HighlightOffIcon fontSize="large" />
        </IconButton>
      }
      showDivider={false}
    >
      <CardContent>
        <InventoryTimelineCard
          inventoryId={match?.params?.id}
          setHeaderData={setHeaderData}
        />
      </CardContent>
      <CardActions>
        <Button onClick={handleCancel} size="large">
          Close
        </Button>
      </CardActions>
    </CrewCard>
  );
};

export const InventoryTimelineCard = ({ inventoryId, setHeaderData }) => {
  const [currentInventory, setCurrentInventory] = useState();
  const [inboundShipment, setInboundShipment] = useState();
  const [lineItems, setLineItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState([]);
  const [dialogTitle, setDialogTitle] = useState();
  const [isInventoryExceptionsOpen, setIsInventoryExceptionsOpen] =
    useState(false);
  const [isInboundExceptionsOpen, setIsInboundExceptionsOpen] = useState(false);
  const [invalidIdError, setInvalidIdError] = useState();
  const [loading, setLoading] = useState();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const classes = useStyles();
  const notify = useNotify();

  useEffect(() => {
    getInventory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getInventory = async () => {
    setLoading(true);
    try {
      debugger;
      let response = await API.graphql(
        graphqlOperation(getInventorieTimeline, { id: inventoryId }),
      );
      let dbInventory = response.data.getInventorie;
      if (!dbInventory) {
        setInvalidIdError(`Inventory ID ${inventoryId} doesn't exist.`);
        return;
      }
      setHeaderData &&
        setHeaderData({
          productName: dbInventory.productName,
          accountName: dbInventory.accountName,
        });
      setCurrentInventory(dbInventory);
      setInboundShipment(dbInventory.inboundShipment);
      const lineItems = dbInventory.shipmentLineItems.items;
      const lineItemMap = {};
      lineItems.forEach((itm) => (lineItemMap[itm.outboundShipmentId] = itm));
      debugger;
      const promiseList = [];
      Object.keys(lineItemMap).forEach((outboundShipmentId) => {
        promiseList.push(
          API.graphql(
            graphqlOperation(getOutboundShipmentTimeline, {
              id: outboundShipmentId,
            }),
          ),
        );
      });
      response = await Promise.all(promiseList);
      response.forEach(
        (itm) =>
          (lineItemMap[itm.data.getOutboundShipment.id].outboundShipment =
            itm.data.getOutboundShipment),
      );
      lineItems.sort((a, b) => {
        const dateA = a.outboundShipment?.createDateTime;
        const dateB = b.outboundShipment?.createDateTime;

        if (dateA && dateB) {
          return dateA.localeCompare(dateB);
        } else if (dateA) {
          return 1; // `a` comes after `b`
        } else if (dateB) {
          return -1; // `a` comes before `b`
        } else {
          return 0; // both dates are undefined
        }
      });
      setLineItems(lineItems);
    } catch (err) {
      logError("InventoryTimelineCard:getInventory", err, notify);
    } finally {
      setLoading(false);
    }
  };

  const showHistory = (historyType, item) => {
    debugger;
    setOpen(true);
    if (historyType === "inbound") {
      setDialogTitle("Inbound History");
      setDialogData(inboundShipment.history);
    } else if (historyType === "outbound") {
      setDialogTitle("Outbound History");
      setDialogData(item.outboundShipment.history);
    } else if (historyType === "inventory") {
      setDialogTitle("Inventory History");
      setDialogData(currentInventory.history);
    } else if (historyType === "inventoryItem") {
      setDialogTitle("Inventory Item History");
      setDialogData(item.history);
    } else if (historyType === "lineItem") {
      setDialogTitle("Shipment Line Item History");
      setDialogData(item.history);
    }
  };

  const showNotes = (noteType, lineItem) => {
    debugger;
    setOpen(true);
    if (noteType === "inbound") {
      setDialogTitle("Inbound Notes");
      setDialogData(inboundShipment.notes ? inboundShipment.notes : []);
    } else if (noteType === "outbound") {
      setDialogTitle("Outbound Notes");
      setDialogData(
        lineItem.outboundShipment.notes ? lineItem.outboundShipment.notes : [],
      );
    } else if (noteType === "shipment") {
      setDialogTitle("Line Item Notes");
      setDialogData(lineItem.notes ? lineItem.notes : []);
    } else if (noteType === "inventory") {
      setDialogTitle("Inventory Notes");
      setDialogData(currentInventory.notes ? currentInventory.notes : []);
    }
  };

  const hideHistory = () => {
    setOpen(false);
  };

  const getQuantityText = (quantity) => {
    if (!quantity) return "N/A";
    const qty = Number(quantity || 0).toLocaleString("en-US", {
      maximumFractionDigits: 2,
    });
    return isSmall
      ? qty
      : `${qty} ${getUnitName(currentInventory?.inventoryUOM)}`;
  };

  const formatDate = (date) => {
    if (!date) return "N/A";
    return format(new Date(date), "MM/dd/yyyy");
  };

  const isNotesDisabled = (itm) => !itm || !itm.notes || itm.length === 0;
  const isHistoryDisabled = (itm) => !itm || !itm.history || itm.length === 0;

  if (invalidIdError)
    return (
      <CardContent>
        <Typography color="error">{invalidIdError}</Typography>
      </CardContent>
    );

  const getInventoryView = () => {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Date Received:{" "}
            {formatDate(currentInventory?.receivedAt, "MM/dd/yyyy hh:mm a")}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Load Type: {currentInventory?.reloadYardCommodity?.commodity?.name}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Account: {currentInventory?.accountName}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Exception: {currentInventory?.hasException ? "Yes" : "No"}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Product: {currentInventory?.productName}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Product Code:{" "}
            {currentInventory?.productCode
              ? currentInventory.productCode
              : "N/A"}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Lot No: {currentInventory?.lotNumber}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Lot Type: {currentInventory?.lotType}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Area: {currentInventory?.area.name}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Zone: {inboundShipment?.zone?.name}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Qty Received: {getQuantityText(currentInventory?.quantityReceived)}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Qty Onhand: {getQuantityText(currentInventory?.quantityOnHand)}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Qty Committed:{" "}
            {getQuantityText(currentInventory?.quantityCommitted)}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Qty Available:{" "}
            {getQuantityText(
              currentInventory?.quantityOnHand -
                currentInventory?.quantityCommitted,
            )}
          </Typography>
        </Grid>
        {currentInventory?.customFields && (
          <Grid item xs={12} md={6}>
            <CustomFieldsMobile
              recordFields={currentInventory?.customFields}
              width={6}
              variant="body2"
              color="textSecondary"
            />
          </Grid>
        )}

        <Grid item xs={12}>
          <Box mt={2} mb={2}>
            <Paper variant="outlined">
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Location</TableCell>
                      <TableCell>Qty Onhand</TableCell>
                      <TableCell>Qty Committed</TableCell>
                      {!isSmall && (
                        <>
                          <TableCell>Is Damaged</TableCell>
                          <TableCell>History</TableCell>
                        </>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {currentInventory?.inventoryItems.items.map((itm) => (
                      <TableRow key={itm.id}>
                        <TableCell>{itm.locationFullName}</TableCell>
                        <TableCell>
                          {getQuantityText(itm.quantityOnHand)}
                        </TableCell>
                        <TableCell>
                          {getQuantityText(itm.quantityCommitted)}
                        </TableCell>
                        {!isSmall && (
                          <>
                            <TableCell>
                              {itm.isDamaged ? <ExceptionIcon /> : "No"}
                            </TableCell>
                            <TableCell>
                              <IconButton
                                onClick={() =>
                                  showHistory("inventoryItem", itm)
                                }
                                className={classes.historyButton}
                                disabled={isHistoryDisabled(currentInventory)}
                              >
                                <HistoryIcon />
                              </IconButton>
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Box>
        </Grid>
        {getInventoryActions()}
        <Grid item xs={12}>
          <PhotoManager
            parentId={currentInventory?.id}
            viewOnly={true}
            justifyContent="start"
          />
        </Grid>
      </Grid>
    );
  };

  const getInventoryActions = () => {
    return isSmall ? (
      <Grid item xs={12}>
        <IconButton
          onClick={() => showHistory("inventory")}
          className={classes.historyButton}
          disabled={isHistoryDisabled(currentInventory)}
        >
          <HistoryIcon />
        </IconButton>
        <IconButton
          onClick={() => showNotes("inventory")}
          className={classes.historyButton}
          disabled={isNotesDisabled(currentInventory)}
        >
          <NoteOutlinedIcon />
        </IconButton>
        <IconButton
          onClick={() => setIsInventoryExceptionsOpen(true)}
          className={classes.historyButton}
          disabled={!currentInventory?.hasException}
        >
          <ExceptionIcon />
        </IconButton>
      </Grid>
    ) : (
      <Grid item xs={12}>
        <Button
          onClick={() => showHistory("inventory")}
          startIcon={<HistoryIcon />}
          size="medium"
          className={classes.historyButton}
          disabled={isHistoryDisabled(currentInventory)}
        >
          History
        </Button>
        <Button
          onClick={() => showNotes("inventory")}
          startIcon={<NoteOutlinedIcon />}
          size="medium"
          className={classes.historyButton}
          disabled={isNotesDisabled(currentInventory)}
        >
          Notes
        </Button>
        <Button
          onClick={() => setIsInventoryExceptionsOpen(true)}
          startIcon={<ExceptionIcon />}
          size="medium"
          className={classes.historyButton}
          disabled={!currentInventory?.hasException}
        >
          Exceptions
        </Button>
      </Grid>
    );
  };

  const getInboundView = () => {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Place Date:{" "}
            {formatDate(inboundShipment?.placedDateTime, "MM/dd/yyyy hh:mm a")}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Release Date:{" "}
            {formatDate(inboundShipment?.releaseDateTime, "MM/dd/yyyy hh:mm a")}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            PO Number: {inboundShipment?.poNumber}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            PO Number: {inboundShipment?.poNumber}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Lot Number: {inboundShipment?.lotNumber}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Ship From: {inboundShipment?.shipFrom}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Carrier: {inboundShipment?.carrierName}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Rail Car/Trailer No: {inboundShipment?.railCarNumber}
          </Typography>
        </Grid>
        {inboundShipment?.customFields && (
          <Grid item xs={12}>
            <CustomFieldsMobile
              recordFields={inboundShipment?.customFields}
              width={6}
              variant="body2"
              color="textSecondary"
            />
          </Grid>
        )}

        <Grid item xs={12}>
          <Button
            onClick={() => showHistory("inbound")}
            startIcon={<HistoryIcon />}
            size="medium"
            className={classes?.historyButton}
            disabled={isHistoryDisabled(inboundShipment)}
          >
            History
          </Button>
          <Button
            onClick={() => showNotes("inbound")}
            startIcon={<NoteOutlinedIcon />}
            size="medium"
            className={classes.historyButton}
            disabled={isNotesDisabled(inboundShipment)}
          >
            Notes
          </Button>
          <Button
            onClick={() => setIsInboundExceptionsOpen(true)}
            startIcon={<ExceptionIcon />}
            size="medium"
            className={classes.historyButton}
            disabled={!inboundShipment?.hasException}
          >
            Exceptions
          </Button>
        </Grid>
        <Grid item xs={12}>
          <PhotoManager
            parentId={inboundShipment?.id}
            viewOnly={true}
            justifyContent="start"
          />
        </Grid>
      </Grid>
    );
  };

  const getOutboundActions = (itm) => {
    return isSmall ? (
      <Grid item xs={12}>
        <IconButton
          onClick={() => showHistory("outbound", itm)}
          className={classes.historyButton}
          disabled={isHistoryDisabled(itm.outboundShipment)}
        >
          <HistoryIcon />
        </IconButton>
        <IconButton
          onClick={() => showNotes("outbound", itm)}
          className={classes.historyButton}
          disabled={isNotesDisabled(itm.outboundShipment)}
        >
          <NoteOutlinedIcon />
        </IconButton>
      </Grid>
    ) : (
      <Grid item xs={12}>
        <Button
          onClick={() => showHistory("outbound", itm)}
          startIcon={<HistoryIcon />}
          size="medium"
          className={classes.historyButton}
          disabled={isHistoryDisabled(itm.outboundShipment)}
        >
          History
        </Button>
        <Button
          onClick={() => showNotes("outbound", itm)}
          startIcon={<NoteOutlinedIcon />}
          size="medium"
          className={classes.historyButton}
          disabled={isNotesDisabled(itm.outboundShipment)}
        >
          Notes
        </Button>
      </Grid>
    );
  };

  const getOutboundView = (itm) => {
    const totalQuantity = calcTotalQuantity(itm.outboundShipment);

    return (
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            PO Number:{" "}
            {itm.outboundShipment.poNumber
              ? itm.outboundShipment.poNumber
              : "N/A"}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Pickup Number:{" "}
            {itm.outboundShipment.pickupNumber
              ? itm.outboundShipment.pickupNumber
              : "N/A"}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Status: {itm.outboundShipment.status}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Qty: {getQuantityText(totalQuantity)}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Departure Date:{" "}
            {formatDate(
              itm.outboundShipment.departureDateTime,
              "MM/dd/yyyy hh:mm a",
            )}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="textSecondary">
            Carrier: {itm.outboundShipment.carrierName}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box mt={2} mb={2}>
            <Paper variant="outlined">
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Location</TableCell>
                      <TableCell>Quantity</TableCell>
                      {!isSmall && (
                        <>
                          <TableCell>History</TableCell>
                          <TableCell>Notes</TableCell>
                        </>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {itm.inventoryItems.items.map((shipmentItem) => (
                      <TableRow key={itm.id}>
                        <TableCell>
                          {shipmentItem.inventoryItem.locationFullName}
                        </TableCell>
                        <TableCell>
                          {getQuantityText(shipmentItem.quantityToPick)}
                        </TableCell>
                        {!isSmall && (
                          <>
                            <TableCell>
                              <IconButton
                                onClick={() => showHistory("lineItem", itm)}
                                size="small"
                                disabled={isHistoryDisabled(itm)}
                              >
                                <HistoryIcon />
                              </IconButton>
                            </TableCell>
                            <TableCell>
                              <IconButton
                                onClick={() =>
                                  showNotes("shipment", shipmentItem)
                                }
                                size="small"
                                disabled={isNotesDisabled(itm)}
                              >
                                <NoteOutlinedIcon />
                              </IconButton>
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Box>
        </Grid>
        {itm.outboundShipment.transfer && (
          <>
            <Grid item xs={12} md={6}>
              <Typography variant="body2" color="textSecondary">
                Is Transfer: true
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="body2" color="textSecondary">
                Transfer Account Name:{" "}
                {itm.outboundShipment.transferToAccountName}
              </Typography>
            </Grid>
          </>
        )}
        <Grid item xs={12} md={6}></Grid>
        {itm.outboundShipment.customFields && (
          <Grid item xs={12}>
            <CustomFieldsMobile
              recordFields={itm.outboundShipment.customFields}
              width={6}
              variant="body2"
              color="textSecondary"
            />
          </Grid>
        )}
        {getOutboundActions(itm)}
        <Grid item xs={12}>
          <PhotoManager
            parentId={itm?.outboundShipment?.id}
            viewOnly={true}
            justifyContent="start"
          />
        </Grid>
      </Grid>
    );
  };

  const getSmallView = () => {
    return (
      <>
        <Paper variant="outlined" className={classes.paper}>
          <Typography variant="h6" gutterBottom>
            Inventory
          </Typography>
          {getInventoryView()}
        </Paper>
        <Paper variant="outlined" className={classes.paper}>
          <Typography variant="h6" gutterBottom>
            Inbound
          </Typography>
          {getInboundView()}
        </Paper>
        {lineItems?.map((itm) => (
          <Paper variant="outlined" className={classes.paper}>
            <Typography variant="h6" gutterBottom>
              Outbound
            </Typography>
            {getOutboundView(itm)}
          </Paper>
        ))}
      </>
    );
  };

  const getLargeView = () => {
    return (
      <Timeline>
        <TimelineItem>
          <TimelineOppositeContent className={classes.timeLineItem}>
            <Box mt={1.5}>
              <Typography variant="body2" color="textSecondary">
                {formatDate(
                  inboundShipment?.placedDateTime,
                  "MM/dd/yyyy hh:mm a",
                )}
              </Typography>
            </Box>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot color="primary">
              <CheckBoxOutlineBlankIcon />
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Paper variant="outlined" className={classes.paper}>
              {window.appUser.type === UserType.CREW ? (
                <Typography variant="h6" gutterBottom>
                  Inventory
                </Typography>
              ) : (
                <Typography variant="h6" color="secondary" gutterBottom>
                  <Link
                    className={classes.link}
                    to={"/inventories/" + currentInventory?.id}
                  >
                    Inventory
                  </Link>
                </Typography>
              )}
              {getInventoryView()}
            </Paper>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineOppositeContent className={classes.timeLineItem}>
            <Box mt={1.5}>
              <Typography variant="body2" color="textSecondary">
                {formatDate(
                  inboundShipment?.placedDateTime,
                  "MM/dd/yyyy hh:mm a",
                )}
              </Typography>
            </Box>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot color="primary">
              <InboundIcon />
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Paper variant="outlined" className={classes.paper}>
              {window.appUser.type === UserType.CREW ? (
                <Typography variant="h6" gutterBottom>
                  Inbound
                </Typography>
              ) : (
                <Typography variant="h6" color="secondary" gutterBottom>
                  <Link
                    className={classes.link}
                    to={"/inboundShipments/" + inboundShipment?.id}
                  >
                    Inbound
                  </Link>
                </Typography>
              )}
              {getInboundView()}
            </Paper>
          </TimelineContent>
        </TimelineItem>
        {lineItems?.map((itm) => (
          <TimelineItem key={itm.id}>
            <TimelineOppositeContent
              className={
                isSmall ? classes.timeLineItemMobile : classes.timeLineItem
              }
            >
              <Box mt={1.5}>
                <Typography variant="body2" color="textSecondary">
                  {formatDate(
                    itm.outboundShipment.createdAt,
                    "MM/dd/yyyy hh:mm a",
                  )}
                </Typography>
              </Box>
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot color="primary">
                <OutboundIcon />
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Paper variant="outlined" className={classes.paper}>
                {window.appUser.type === UserType.CREW ? (
                  <Typography variant="h6" gutterBottom>
                    Outbound
                  </Typography>
                ) : (
                  <Typography variant="h6" color="secondary" gutterBottom>
                    <Link
                      className={classes.link}
                      to={"/outboundShipments/" + itm.outboundShipment.id}
                    >
                      Outbound
                    </Link>
                  </Typography>
                )}
                {getOutboundView(itm)}
              </Paper>
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    );
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container>
        <Grid item xs={12}>
          {isSmall ? getSmallView() : getLargeView()}
          <Dialog
            open={isInventoryExceptionsOpen}
            onClose={() => setIsInventoryExceptionsOpen(false)}
            scroll={"paper"}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>Inventory Exceptions</DialogTitle>
            <DialogContent>
              <FormControl component="fieldset">
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={currentInventory?.overShipment}
                        disabled
                      />
                    }
                    label="Over Shipment"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={currentInventory?.underShipment}
                        disabled
                      />
                    }
                    label="Under Shipment"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={currentInventory?.isDamaged}
                        disabled
                      />
                    }
                    label="Is Damaged"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={currentInventory?.otherException}
                        disabled
                      />
                    }
                    label="Other Exception"
                  />
                </FormGroup>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setIsInventoryExceptionsOpen(false)}>
                Close
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={isInboundExceptionsOpen}
            onClose={() => setIsInboundExceptionsOpen(false)}
            scroll={"paper"}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>Inbound Exceptions</DialogTitle>
            <DialogContent>
              <FormControl component="fieldset">
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={inboundShipment?.unsafeShipment}
                        disabled
                      />
                    }
                    label="Unsafe Shipment"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={inboundShipment?.brokenSeal}
                        disabled
                      />
                    }
                    label="Broken Seal"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={inboundShipment?.otherException}
                        disabled
                      />
                    }
                    label="Other Exception"
                  />
                </FormGroup>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setIsInboundExceptionsOpen(false)}>
                Close
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={open}
            onClose={hideHistory}
            scroll={"paper"}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>{dialogTitle}</DialogTitle>
            <DialogContent>
              <List>
                {dialogData?.map((itm) => (
                  <>
                    <Divider />
                    <ListItem key={itm.date + itm.text}>
                      <ListItemText
                        primary={`${formatDate(
                          itm.date,
                          "MM/dd/yyyy hh:mm a",
                        )} - ${itm.by}`}
                        secondary={itm.text}
                      />
                    </ListItem>
                  </>
                ))}
              </List>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button onClick={hideHistory}>Close</Button>
            </DialogActions>
          </Dialog>
        </Grid>
      </Grid>
    </>
  );
};
